import ReferenciaDto from '../domain/ReferenciaDto'

export default class CreateReferenciasEnlaceC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, referencia) {
    try {
      const dto = new ReferenciaDto().fromEntity(referencia)
      dto.fk_idPersonal = idPersonal

      const result = await this.#repository.create(idPersonal, dto)

      return result
    } catch (error) {
      throw error
    }
  }
}
